
























































































































import { Component, Watch } from "vue-property-decorator";

import AppVue from "@/AppVue.vue";
import { UserLookups, UserTrainingModel } from "@/core/webapi";
import { ApiService, NotificationProvider } from "@/core/services";
import { AcademicYearSelectCpt } from "@/core/components/common";
import { TrainingRecordStatus } from "@/core/constants";
import moment from "moment";

@Component({
  components: {
    AcademicYearSelectCpt,
  },
})
export default class UserTrainingView extends AppVue {
  lookups = new UserLookups({
    academicYears: [],
  });
  filter: any = {};
  internalLoading = false;
  showDialog = false;
  selectedTrainingSessionId = 0;

  model = new UserTrainingModel({
    latestTrainingSessionId: null,
    latestTrainingSessionTimeBlock: "",
    availableSessions: [],
    trainingRecords: [],
  });

  get hasAvailableSessions() {
    return this.model.availableSessions && this.model.availableSessions.length > 0;
  }

  get isLatestTrainingOver24HoursAway() {
    if (!this.model.latestTrainingStartsAt) {
      return true;
    }

    const now = moment();
    const trainingStartTime = moment(this.model.latestTrainingStartsAt);
    const hoursDifference = trainingStartTime.diff(now, "hours", true);

    return hoursDifference > 24;
  }

  get isLatestTrainingScheduledOrAttended() {
    const statusId = this.model.latestTrainingRecordAttendenceStatusId;
    if (!statusId) {
      return false;
    }

    if (statusId === TrainingRecordStatus.Scheduled || statusId === TrainingRecordStatus.Attended) {
      return true;
    }

    return false;
  }

  get canChangeSession() {
    // Rule 1: If there are no available sessions, return false
    if (!this.hasAvailableSessions) {
      return false;
    }

    if (this.isLatestTrainingOver24HoursAway) {
      return true;
    }

    // Rule 4: If latest training starts within 24 hours or in the past, check status
    if (this.isLatestTrainingScheduledOrAttended) {
      return false;
    }

    return true;
  }

  @Watch("currentAcademicYear")
  async onAcademicYearChanged() {
    await this.initializeModel();
  }

  async created() {
    await this.loadLookups();
    await this.initializeModel();
  }

  async loadLookups() {
    this.isLoading = true;
    try {
      const response = await ApiService.user().getUserLookups(false, false);
      this.lookups = response.data;
    } finally {
      this.isLoading = false;
    }
  }

  changeSessionSlot() {
    this.showDialog = true;
  }

  async confirmChangeSessionSlot() {
    this.showDialog = false;
    await ApiService.user().changeTrainingSessionSlot(this.selectedTrainingSessionId);
    NotificationProvider.success("Slot successfully changed");
    await this.initializeModel();
  }

  private async initializeModel() {
    const response = await ApiService.user().getUserTrainingSessions(this.currentUserId, this.currentAcademicYear);
    this.model = response.data;
    this.selectedTrainingSessionId = this.model.latestTrainingSessionId;
  }
}
